import React from 'react';
import PropTypes from 'prop-types';

import GorkoLink from '@src/components/GorkoLink';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const FilesList = (props) => {
	useStyles(css);
	const { files } = props;

	if (!files) {
		return null;
	}

	return (
		<div className={css.wrap}>
			{files.map(({ url, id, title, extension, size }) => (
				<GorkoLink
					klass={css.item}
					to={url}
					targetBlank
					download
					key={id}
				>
					<div className={css.label}>{title}</div>
					<div className={css.details}>
						<div className={css.extension}>
							{extension.toUpperCase()}
						</div>
						<div className={css.size}>{size}</div>
						<i className={css.icon} />
					</div>
				</GorkoLink>
			))}
		</div>
	);
};

FilesList.propTypes = {
	files: PropTypes.arrayOf(
		PropTypes.shape({
			url: PropTypes.string,
			id: PropTypes.number.isRequired,
			title: PropTypes.string,
			extension: PropTypes.string,
			size: PropTypes.string,
		}),
	),
};

FilesList.defaultProps = {
	files: [],
};

export default FilesList;
